// extracted by mini-css-extract-plugin
export default {"warning":"MethodInfo-warning-pKu"};